define('model/arrayMerge',[], function() {
    'use strict';

    function defaultComparator(first, second) {
        return first === second;
    }

    return function(firstArray, secondArray, comparator) {
        var result, i, j;
        if (!comparator) {
            comparator = defaultComparator;
        }

        result = firstArray.concat(secondArray);
        for (i = 0; i < firstArray.length; i += 1) {
            for (j = firstArray.length; j < result.length; j += 1) {
                if (comparator(result[i], result[j])) {
                    result.splice(j, 1);
                    j -= 1;
                }
            }
        }
        return result;
    };
});

